import * as yup from 'yup';
import * as utils from './utils';
import { Lieu } from '../entities';

export const schemaLieu = yup.object<Partial<Lieu>>({
    name: yup.string().required('Ce champ est requis'),
    adresse: yup.string().nullable(),
    code_postal: yup
        .string()
        //eslint ne permet pas les \d \s
        .matches(
            new RegExp(/^[A-Za-z][0-9][A-Za-z][ ]?[0-9][A-Za-z][0-9]$/),
            'Ce champ doit contenir un code postal valide, ex: A1A 1A1',
        )
        .nullable(),
    created_at: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    ville: yup.string().nullable(),
    province: yup.string().nullable(),
    notes: yup.string().nullable(),
}) as yup.ObjectSchema<Partial<Lieu>>;
